module.exports = __webpack_public_path__ + "static/media/on.3705685f.png";